<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-grid" />Reported Questions
      </slot>
    </CCardHeader>
    <CCardBody>
      <v-client-table :data="reports" :columns="columns" :options="options">
        <template slot="question_id" slot-scope="props">
          <div>
            <router-link :to="{ name: 'QuestionEdit', params: {id: props.row.question_id}}">
              {{props.row.question_id}}
            </router-link>
          </div>
        </template>
        <template slot="status" slot-scope="props">
          <div>
            <span class="badge badge-sm" :class="[props.row.status==='resolved' ? 'badge-success' : 'badge-danger']">{{props.row.status}}</span>
          </div>
        </template>
        <template slot="action" slot-scope="props">
          <div>
            <router-link :to="{ name: 'QuestionReportEdit', params: {id: props.row.id}}">
              <span
                  class="btn btn-warning btn-sm m-1"
                  data-toggle="tooltip"
                  title="Edit"
                  :href="props.row.id"
              >

                <CIcon name="cil-pencil" size="sm" />
              </span>
            </router-link>
            <span @click="handleDelete(props.row.question_id)"
                  class="btn btn-danger btn-sm m-1"
                  data-toggle="tooltip"
                  title="Delete"
                  :href="props.row.question_id"
            >
                <CIcon name="cil-basket" size="sm" />
              </span>
          </div>
        </template>
      </v-client-table>
    </CCardBody>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  name: "QuestionReports",
  data() {
    return {
      reports: [],
      columns: ["question_id", "type","status","resolved_by","action"],
      options: {
        pagination: {nav: "fixed"},
        filterByColumn: true,
        toMomentFormat: "YYYY-MM-DD",
        sortIcon: {
          base: "fa fa-sort",
          up: "fa fa-sort-up",
          down: "fa fa-sort-down",
          is: "fa fa-sort",
        },
      },
    }
  },
  created() {
    this.getQuestionReports();
  },

  methods: {
    getQuestionReports() {
      this.$axios
          .get(`${ADMIN_URL}/question-reports`)
          .then((response) => {
            this.reports = response.data;
          })
          .catch((e) => {
            console.log("error occurs", e);
          });
    },
    handleDelete(id) {
      // console.log('handleDelete  category_id === ', category_id);
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
      }).then(result => {
        if(result.value) {
          this.deleteQuestion(id);
        }
      }).catch(error => {
        //console.log('Sweetalert ERROR');
      });
    },
    deleteQuestion(id)
    {
      this.$axios
          .delete(`${ADMIN_URL}/question-reports/${id}`)
          .then((response) => {
            this.$swal("Success", response.data.message, "success");
            this.getQuestions()
          })
          .catch((error) => {
            console.log("Error  ... ", error.response);
            this.$swal("Error", error.response.message, "error");
          });
    }
  }
}
</script>

<style scoped>

</style>
